import { usePromise as useCorePromise } from './promiseState'

import { UseMutationConfig, useResolvedPromise } from './useResolvedPromise'

/**
 * Wraps the base `usePromise` from `~/shared/hooks/promiseState` with Lucian-specific
 * side effects via useResolvedPromise. This includes some code duplication
 * to get the types to match the base hook.
 */
const DEFAULT_CONFIG = { initialLoading: true }
export function usePromise<P, E = unknown>(
  getPromise: () => Promise<P>,
  config: UseMutationConfig = DEFAULT_CONFIG,
) {
  const promise = useCorePromise<P, E>(getPromise, config)
  useResolvedPromise(promise, { ...DEFAULT_CONFIG, ...config })
  return promise
}
